import { BaseModel } from "./base"

export enum ArticuloMovimientoTipo {
    Entrada,
    Salida
}

export type ArticuloMovimiento = BaseModel & {
    fecha: string,
    tipo: ArticuloMovimientoTipo,
    descripcion: string,
    articuloId: string,
    articuloNombre: string,
    articuloCodigo: string,
    cantidad: number
}